import React from "react";
import { ReviewProduct, RatingSummary } from "@interfaces/dto/review.dto";
import { progressBarReview } from "@utils/starRate";

interface Props {
  reviewSummary:  RatingSummary[];
}

const ReviewStar = ({ reviewSummary }: Props) => {
  const {
    ratefive,
    ratefour,
    ratethree,
    ratetwo,
    rateone,
    progressWidthFive,
    progressWidthFour,
    progressWidthThree,
    progressWidthTwo,
    progressWidthOne,
  } = progressBarReview({ reviewSummary });

  return (
    <>
      <div className="col-6 col-lg-4 my-2 review-star">
        <ul className="rating">
          <li className="row d-flex justify-content-between">
            <div className="col col-4 m-auto d-flex justify-content-between">
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
            </div>
            <div className="col col-lg-6 p-0 m-auto bar-review">
              <div
                className="bar-review inprogress"
                style={{ width: progressWidthFive }}
              ></div>
            </div>
            <div className="col col-2 m-auto text-center">
              {ratefive !== undefined ? (
                <p className="m-0">{ratefive}</p>
              ) : (
                <p className="m-0">0</p>
              )}
            </div>
          </li>
          <li className="row d-flex justify-content-between">
            <div className="col col-4 m-auto d-flex justify-content-between">
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
              <i className="icon icon-star " />
            </div>
            <div className="col col-lg-6 p-0 m-auto bar-review">
              <div
                className="bar-review inprogress"
                style={{ width: progressWidthFour }}
              ></div>
            </div>
            <div className="col col-2 m-auto text-center">
              <p className="m-0">
                {" "}
                {ratefour !== undefined ? (
                  <p className="m-0">{ratefour}</p>
                ) : (
                  <p className="m-0">0</p>
                )}
              </p>
            </div>
          </li>
          <li className="row d-flex justify-content-between">
            <div className="col col-4 m-auto d-flex justify-content-between">
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
              <i className="icon icon-star " />
              <i className="icon icon-star " />
            </div>
            <div className="col col-lg-6 p-0 m-auto bar-review">
              <div
                className="bar-review inprogress"
                style={{ width: progressWidthThree }}
              ></div>
            </div>
            <div className="col col-2 m-auto text-center">
              <p className="m-0">
                {" "}
                {ratethree !== undefined ? (
                  <p className="m-0">{ratethree}</p>
                ) : (
                  <p className="m-0">0</p>
                )}
              </p>
            </div>
          </li>
          <li className="row d-flex justify-content-between">
            <div className="col col-4 m-auto d-flex justify-content-between">
              <i className="icon icon-star active" />
              <i className="icon icon-star active" />
              <i className="icon icon-star " />
              <i className="icon icon-star " />
              <i className="icon icon-star " />
            </div>
            <div className="col col-lg-6 p-0 m-auto bar-review">
              <div
                className="bar-review inprogress"
                style={{ width: progressWidthTwo }}
              ></div>
            </div>
            <div className="col col-2 m-auto text-center">
              <p className="m-0">
                {" "}
                {ratetwo !== undefined ? (
                  <p className="m-0">{ratetwo}</p>
                ) : (
                  <p className="m-0">0</p>
                )}
              </p>
            </div>
          </li>
          <li className="row d-flex justify-content-between">
            <div className="col col-4 m-auto d-flex justify-content-between">
              <i className="icon icon-star active" />
              <i className="icon icon-star " />
              <i className="icon icon-star " />
              <i className="icon icon-star " />
              <i className="icon icon-star " />
            </div>
            <div className="col col-lg-6 p-0 m-auto bar-review">
              <div
                className="bar-review inprogress"
                style={{ width: progressWidthOne }}
              ></div>
            </div>
            <div className="col col-2 m-auto text-center">
              <p className="m-0">
                {" "}
                {rateone !== undefined ? (
                  <p className="m-0">{rateone}</p>
                ) : (
                  <p className="m-0">0</p>
                )}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ReviewStar;
